import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative flex flex-col min-h-full p-2 bg-white border shadow-md rounded-3xl shadow-black/5 ring-1 ring-black/5 show-card dark:border-gray-200 dark:border dark:bg-gray-800 border-clay-200"
}
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { class: "flex flex-col flex-1 p-4" }
const _hoisted_5 = { class: "mt-2 font-medium text-base/7" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-clay-950 text-sm/5" }
const _hoisted_10 = { class: "flex-1 mt-2 text-gray-600 text-sm/6" }
const _hoisted_11 = {
  key: 0,
  class: "relative min-w-full slider-hidden"
}
const _hoisted_12 = ["href", "alt"]
const _hoisted_13 = {
  key: 1,
  class: "relative min-w-full slider-hidden",
  title: "This guide has active opportunities"
}
const _hoisted_14 = { class: "z-10 mt-4 text-xs leading-5 text-center text-electric-700" }
const _hoisted_15 = ["href", "alt", "title"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "z-10 flex items-center gap-3 mx-auto mt-6 slider-hidden" }
const _hoisted_19 = {
  key: 1,
  class: "flex items-start space-x-4 text-base sm:text-sm"
}
const _hoisted_20 = { class: "flex-none mt-1" }
const _hoisted_21 = ["href", "alt", "title"]
const _hoisted_22 = ["src", "alt", "title"]
const _hoisted_23 = { class: "flex-grow" }
const _hoisted_24 = ["href", "alt", "title"]
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "text-xs" }


import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {ShowDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowCard',
  props: {
    show: {},
    style: {}
  },
  setup(__props: any) {

const props = __props;

const show: ShowDto = props.show;
const style: string = props.style ?? 'card'; // Provide default value using nullish coalescing


return (_ctx: any,_cache: any) => {
  return (_unref(style) === 'card')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: ` /${_unref(show).urlSlug}`,
          alt: _unref(show).title,
          title: _unref(show).title,
          class: "guide-img-container"
        }, [
          _createElementVNode("img", {
            src: _unref(show).logo,
            alt: `${_unref(show).title} logo`,
            title: `${_unref(show).title} logo`,
            class: "object-cover mx-auto sm:w-full aspect-square rounded-2xl max-w-80 w-full"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              href: `/${_unref(show).urlSlug}`,
              alt: _unref(show).title,
              title: _unref(show).title,
              class: "text-clay-950"
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute inset-0" }, null, -1)),
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(show).title), 1)
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_unref(show).category), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(show).plotOverviewExcerpt), 1),
          (_unref(show).hasScript)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("a", {
                  class: "z-10 block px-2 py-1 mt-4 text-xs font-medium text-center rounded-full text-clay-950 light:bg-clay-50 dark:bg-gray-600",
                  href: `/${_unref(show).urlSlug}/script`,
                  alt: `Full text for ${_unref(show).title}`,
                  title: "`Full text for ${show.title}`"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", {
                    style: {"font-size":"0.85rem"},
                    class: ""
                  }, [
                    _createElementVNode("i", { class: "mr-1 far fa-file-alt" }),
                    _createTextVNode(" Full Script ")
                  ], -1)
                ]), 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          (_unref(show).opportunityCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-none inline-block p-1 mr-1 rounded-full bg-emerald-500/20" }, [
                    _createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500" })
                  ], -1)),
                  _createElementVNode("a", {
                    href: `/${_unref(show).urlSlug}/opportunities`,
                    alt: `Opportunities for ${_unref(show).title}`,
                    title: `Opportunities for ${_unref(show).title}`,
                    class: "border-b hover:border-none"
                  }, [
                    _createTextVNode(_toDisplayString(_unref(show).opportunityCount) + " active ", 1),
                    (_unref(show).opportunityCount === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "opportunity"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, "opportunities"))
                  ], 8, _hoisted_15)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Fanning, {
              id: _unref(show).id,
              "number-of-fans": _unref(show).fanCount
            }, null, 8, ["id", "number-of-fans"]),
            _createVNode(Bookmarking, {
              id: _unref(show).id
            }, null, 8, ["id"])
          ])
        ])
      ]))
    : (_unref(style) === 'stack')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              href: `/${_unref(show).urlSlug}`,
              alt: _unref(show).title,
              title: _unref(show).title
            }, [
              _createElementVNode("img", {
                class: "object-cover w-8 rounded-lg shadow-lg",
                src: _unref(show).logo,
                alt: `${_unref(show).title} logo`,
                title: `${_unref(show).title} logo`
              }, null, 8, _hoisted_22)
            ], 8, _hoisted_21)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("a", {
              href: `/${_unref(show).urlSlug}`,
              alt: _unref(show).title,
              title: _unref(show).title,
              class: "block font-medium hover:underline"
            }, [
              _createElementVNode("h3", _hoisted_25, _toDisplayString(_unref(show).title), 1)
            ], 8, _hoisted_24),
            _createElementVNode("dl", null, [
              _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "sr-only" }, "Category", -1)),
              _createElementVNode("dd", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(show).category), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})